<template>
        <div class="course-wrap bg-bblack">
            <div class="course-inner "> 
                <!--基础班-->
                <div class="zj-main clearfix"> <a name="kclb"></a> 
                    <!--基础班标题-->
                    <div class="wx-dxbj-title-box">
                        <div class="wx-dxbj-title-201811"></div>
                        <div class="wx-dxbj-title-201811-info">组合班级由基础班级组成，部分基础班级可单独选购，基础班级有独立的有效期</div>
                    </div>
                    <!--基础班标题 end-->
                    
                    <div class="bg-cor pad-80">
                        <div class="layout-box">
                            <div class="basis_warp"> <a name="jcbj"></a>
                                <div class="study-tab-box bg-sblue" >
                                    <div class="study-tab-nav">
                                        <a href="javascript:;" v-if="list[0].length>0" :class="type==1?'curr':''" @mouseover="changeType(1)">套餐班级</a>
                                        <a href="javascript:;" v-if="list[1].length>0" :class="type==2?'curr':''" @mouseover="changeType(2)">单买班级</a>
                                        <!-- <a href="javascript:;" v-if="list[2].length>0" :class="type==3?'curr':''" @mouseover="changeType(3)">不可单买</a> -->
                                    </div>
                                    <div class="wxkc-list-tab-box clearfix" v-if="list[type-1].length>0"> 
                                        <i class="tj_icon" style="display: none;"></i>
                                        <div class="wxkc-main js-wxkc-box">
                                        <div class="wxkc-hd">
                                            <span @mouseover="changeIndex(i)"  :class="index==i?'wxkc-bz  wxkc-on':'wxkc-bz'" v-for="(v,i) in list[type-1]" :key="i">{{v.BzCName.replace("取证","VIP").replace("取证VIP","VIP")}}</span>
                                        </div>
                                            <div class="wxkc-bd">
                                                <div class="wxkc-list" style="display: block;">
                                                    <div class="wxkc-list-tips js-tips-display">
                                                        <p class="wxkc-list-tips-list">
                                                            <span class="service-name">班级介绍：</span>
                                                            {{list[type-1][index].Explain.length>0?list[type-1][index].Explain.replace("取证","VIP").replace("取证VIP","VIP"):"暂无班级介绍"}}
                                                        </p>
                                                        <p class="wxkc-list-tips-list"><span class="service-name">配套服务：</span>
                                                        <em class="service-name-cont" v-if="list[type-1][index].ExamProductList"><i class="icon"></i>在线题库</em>
                                                        <em class="service-name-cont"><i class="icon"></i>移动课堂</em><em class="service-name-cont"><i class="icon"></i>讲义下载</em><em class="service-name-cont"><i class="icon"></i>课件下载</em></p>
                                                        <p class="wxkc-list-tips-list">
                                                            <span class="service-name">学习期限：</span>
                                                            <span v-if="list[type-1][index].Yxq>0">{{list[type-1][index].Yxq}}个月</span>
                                                            <span v-else>至{{list[type-1][index].Validity.split(' ')[0]}}止</span>
                                                            
                                                        </p>
                                                    </div>
                                                    <table class="wxkc-table">
                                                        <thead>
                                                        <tr>
                                                            <th class="wxkc-name">课程专业名称</th>
                                                            <th class="wxkc-tc">讲师</th>
                                                            <th class="wxkc-ks">讲数</th>
                                                            <th class="wxkc-p2">价格</th>
                                                            <th class="wxkc-st">免费体验</th>
                                                            <th class="wxkc-bm">报名</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(v,i) in list[type-1][index].Details" :key="i">
                                                                <td class="wxkc-name"><span class="wxkc-cname">{{v.MyClassName.replace("取证","VIP").replace("取证VIP","VIP")}}</span></td>
                                                                <td class="wxkc-tc">{{v.Teacher}}</td>
                                                                <td class="wxkc-ks">{{v.CourseNum}}</td>
                                                                <td class="wxkc-p2">￥{{v.GoodPrice}}</td>
                                                                <td class="wxkc-st"><a class="wxkc-st-bg" target="_blank" :href="'/course/study?mid='+v.MyClassId"></a></td>
                                                                <td class="wxkc-bm"><a class="wxkc-bm-bg" target="_blank" :href="'/shopping?myclassid='+v.MyClassId"></a></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--基础班 end--> 
            </div>
        </div>
</template>
<script>
import { getAllCourse } from '@/request/request.js'
export default {
    name: 'App',
        props: {
            classEname: String,
        },
    components: {
      
    },
    data() {
        return {
            type:1,
            list:[[],[],[]],
            index:0
        };
    },
    created(){
        var data=sessionStorage.getItem("quanbubanji"+this.classEname);
        if(data==undefined){
            getAllCourse({classEname:this.classEname,type:1},(res)=>{
                this.$set(this.list,0,res.Result);
            });            
            getAllCourse({classEname:this.classEname,type:2},(res)=>{
                this.$set(this.list,1,res.Result);
                setTimeout(() => {
                    sessionStorage.setItem("quanbubanji"+this.classEname,JSON.stringify(this.list));
                }, 500);
            });            
            // getAllCourse({classEname:this.classEname,type:3},(res)=>{
            //     this.$set(this.list,2,res.Result);

            // });
        }else{
            this.list=JSON.parse(data);
        }

    },
    methods:{
        changeIndex(i){
            this.index=i;
        },
        changeType(i){
            this.type=i;
            if(this.list[this.type-1].length==0){
                getAllCourse({classEname:this.classEname,type:this.type},(res)=>{
                    this.$set(this.list,this.type-1,res.Result);
                });
            }
        }
    },
}
</script>